class LandingCarousel extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    // const selectors = {
    //     landingSlider: '.landing__new-arrivals__content__slider',
    // };
    // New Arrivals Section
    const landingSection = () => {
      const slider = this.querySelector('.swiper')
      function landingSlider() {
        const sliderOptions = {
          slidesPerView: 2.1,
          spaceBetween: 4,
          centeredSlides: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
          },
          loop: false,
          breakpoints: {
            768: {
              spaceBetween: 16,
              slidesPerView: 3,
              centeredSlides: false,
              threshold: 32,
              navigation: {
                nextEl: '.home__new-arrivals__content__slider__next',
                prevEl: '.home__new-arrivals__content__slider__prev',
              },
            },
            1024: {
              spaceBetween: 16,
              slidesPerView: 4,
              centeredSlides: false,
              threshold: 32,
              navigation: {
                nextEl: '.home__new-arrivals__content__slider__next',
                prevEl: '.home__new-arrivals__content__slider__prev',
              },
            },
          },
        }

        new Swiper(slider, sliderOptions)
      }

      landingSlider()
    }
    // End New Arrivals Section
    landingSection()
  }
}

customElements.define('landing-carousel', LandingCarousel)
